export default {
      id: "feuilles-usage",
      viewBox: "0 0 165 210",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#feuilles-usage",
      toString: function () {
        return this.url;
      }
    }